/* Niclas + ChatGPT | 2026-10-02 | Preserve US/CA → EU suggestion; accessible dismissal. */
(function () {
  const host = location.hostname.replace(/^www\./, '');
  if (!['us.avolt.com', 'ca.avolt.com'].includes(host)) return;
  if (/googlebot|bingbot|adsbot|duckduckbot|yandexbot|baiduspider|slackbot|twitterbot|linkedinbot|gptbot|oai-searchbot/i.test(navigator.userAgent || '')) return;
  const key = `avolt_notified_eu_${host}`;
  try { if (sessionStorage.getItem(key)) return; } catch {}
  const modal = document.getElementById('avoltStoreModal');
  const go = document.getElementById('avoltGoEU');
  const stay = document.getElementById('avoltStayNA');
  if (!modal || !go || !stay) return;
  const root = window.Shopify?.routes?.root || '/';
  fetch(`${root}browsing_context_suggestions.json?country[enabled]=true`)
    .then(res => res.json())
    .then(data => {
      const country = data.detected_values?.country?.handle;
      if (!country || ['US', 'CA'].includes(country)) return;
      stay.textContent = host === 'ca.avolt.com' ? 'Stay on Canadian store' : 'Stay on US store';
      let previousFocus;
      const close = () => {
        try { sessionStorage.setItem(key, 'true'); } catch {}
        modal.classList.remove('is-visible');
        modal.setAttribute('aria-hidden', 'true');
        previousFocus?.focus();
      };
      go.onclick = () => {
        const path = location.pathname;
        location.href = 'https://avolt.com' + (path.includes('/collections/') ? path : '/');
      };
      stay.onclick = close;
      modal.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); close(); }
        if (event.key === 'Tab') {
          if (event.shiftKey && document.activeElement === go) { event.preventDefault(); stay.focus(); }
          else if (!event.shiftKey && document.activeElement === stay) { event.preventDefault(); go.focus(); }
        }
      });
      setTimeout(() => {
        previousFocus = document.activeElement;
        modal.classList.add('is-visible');
        modal.setAttribute('aria-hidden', 'false');
        go.focus();
      }, 800);
    }).catch(() => {});
})();

/* AVOLT | 2026-10-14 | Keep Judge.me carousel product links on the current US/CA market.
   Judge.me returns the primary store domain even when the customer is browsing Canada. */
(function () {
  if (!['us.avolt.com', 'ca.avolt.com'].includes(location.hostname.replace(/^www\./, ''))) return;
  const selector = '.jdgm-cards-carousel a[href]';
  const observed = new WeakSet();
  function normalize(anchor) {
    let url;
    try { url = new URL(anchor.getAttribute('href'), location.origin); } catch { return; }
    if (!['us.avolt.com', 'ca.avolt.com'].includes(url.hostname.replace(/^www\./, ''))) return;
    const match = url.pathname.match(/\/products\/[^/]+\/?$/);
    if (!match) return;
    const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
    const href = root + match[0] + url.search + url.hash;
    if (anchor.getAttribute('href') !== href) anchor.setAttribute('href', href);
  }
  function setup() {
    document.querySelectorAll('.jdgm-cards-carousel').forEach(carousel => {
      carousel.querySelectorAll('a[href]').forEach(normalize);
      if (observed.has(carousel)) return;
      observed.add(carousel);
      new MutationObserver(() => carousel.querySelectorAll('a[href]').forEach(normalize))
        .observe(carousel, { childList: true, subtree: true });
    });
  }
  document.addEventListener('click', event => {
    const anchor = event.target.closest?.(selector);
    if (anchor) normalize(anchor);
  }, true);
  document.addEventListener('shopify:section:load', setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, { once: true });
  else setup();
})();
